<script>
	import { fade } from "svelte/transition";
	import { cubicOut } from "svelte/easing";
	import { onMount } from 'svelte';
	
	import LineChart from "./line_chart/LineChart.svelte";
	import PointsWrapper from "./points/PointsWrapper.svelte";
	// import Legend from "./common/Legend.svelte";

	import { formatFloat, formatFloatAdaptive, percent } from "../utils";
	import { weaponsSold, childrenDeathsData, dataShootingsUS } from "../data";
	import { colors } from "../config";

	export let id;
	export let charts;
	export let headline;
	export let lead;
	export let layout;
	export let legendItems;
	export let transitionIn = { duration: 2000, easing: cubicOut};
	export let transitionOut = { duration: 2000, easing: cubicOut };
	// $: mapBorders = 'transparent';
	// $: mapRegions = '#000000';
	

	$: numberOfCharts = (charts && charts.length) || 1;
	$: showPoints = charts.includes("points");
	$: showLineChartChildren = charts.includes("linechart_children");
	$: showLineChartWeapons = charts.includes("linechart_weapons_sold");
	$: onlyPoints = numberOfCharts === 1 && showPoints;

	let pointsChartSubheading;
	$: {
		if (onlyPoints && layout === 'histogram') {
			pointsChartSubheading = "NACH HÄUFIGKEIT";
		} else if (layout === 'beeswarm') {
			pointsChartSubheading = "NACH ZAHL DER OPFER";
		} else {
			pointsChartSubheading = null;
		}
	}

	let pointsRealWidth = 0;
	let lineChartChildrenRealWidth = 0;
	let lineChartWeaponsRealWidth = 0;

	const weaponsSoldYTicks = [5000000, 10000000, 15000000, 20000000, 25000000];
	const childrenDeathsYTicks = [1000, 2000, 3000, 4000];

	const getLastYear = (d) => d.values[d.values.length - 1].year.getFullYear();

	const frmtChildren = formatFloat({ digits: 0 });
	const frmtChildrenLabel = formatFloat({ digits: 0, postfix: " Tote" });

	const frmtWeapons = formatFloatAdaptive({ digits: 0 });
	const frmtWeaponsLabel = formatFloatAdaptive({ digits: 1, adaptive: true, decimal: true });

	// ///////////////////////////////////////////////////////////
	// loading animation
	// ///////////////////////////////////////////////////////////

	
	
	let showImage = false;
	let showMap = false;
	let showMapMap = false;
	let hideFilter = false;
	let wasLead = false;
	function loadingAnimationLead() {
		setTimeout(() => {
			showImage = true;
		}, 1000);
		
		setTimeout(() => {
			showMap = true;
		}, 2000);
		
		setTimeout(() => {
			showMapMap = true;
		}, 2800);

		// setTimeout(() => {
		// 	showImage = false;
		// }, 4000);
		
		setTimeout(() => {
			hideFilter = true;
		}, 4000);
		
	}
	
	onMount(loadingAnimationLead);

	const transitionParams = { delay: 900, duration: 500 }
</script>

<div
	class="shootings"
	{id}
	class:narrow={numberOfCharts !== 1}
	class:lead
	class:extra-mobile-height={!!pointsChartSubheading && onlyPoints}
	in:fade={transitionIn}
	out:fade={transitionOut}
>
	<div
		class="container-shootings points {layout}"
		style:width={onlyPoints ? null : percent(showPoints ? 100 / numberOfCharts : 0)}
		style:height={onlyPoints ? null : percent(showPoints ? 100 / numberOfCharts : 0)}
		style:opacity={+showPoints}
		bind:clientWidth={pointsRealWidth}
	>
		<div class="headline">
			<span>{onlyPoints ? 'MASS SHOOTINGS IN DEN USA SEIT 1982' : 'MASS SHOOTINGS IN DEN USA'}</span>
			{#if !!pointsChartSubheading}
				<span>{pointsChartSubheading}</span>
			{/if}
		</div>
		<div class="chart_container {layout}">
			{#if pointsRealWidth !== 0}
				<div class="inner-container">
					{#if showMap}
						<div class="pointswrapperwrapperwrapper" class:showMapMap={showMapMap} class:hideFilter={hideFilter}>
						<PointsWrapper {...$$props} {onlyPoints} data={dataShootingsUS} />
						</div>
					{/if}
					{#if lead}
					<img src="{PATH}assets/images/lead.jpg" class="lead_img" class:showImage={showImage}>
					{/if}
				</div>
			{/if}
		</div>
	</div>
	<div
		class="container-shootings linechart-children"
		style:width="{showLineChartChildren ? 100 / numberOfCharts : 0}%"
		style:opacity={+showLineChartChildren}
		bind:clientWidth={lineChartChildrenRealWidth}
	>
		<!-- do not draw the line chart if the width transition is already over i.e. the real width is 0 -->
		{#if lineChartChildrenRealWidth !== 0}
			<div class="headline" in:fade="{transitionParams}">
				TOTE KINDER UND JUGENDLICHE
				DURCH WAFFEN IN DEN USA
			</div>
			<div class="chart_container" in:fade="{transitionParams}">
				<LineChart
					data={childrenDeathsData.map((d) => ({ year: d.year, number_of_deaths: d.number_of_deaths }))}
					yTicks={childrenDeathsYTicks}
					label={getLastYear}
					formatTickY={frmtChildren}
					formatValueLabel={frmtChildrenLabel}
					xTickPosition="top"
					paddingLeft={45}
					seriesColors={[colors.lineChildrenDeaths]}
				/>
			</div>
		{/if}
	</div>
	<div
		class="container-shootings linechart-weapons"
		style:width="{showLineChartWeapons ? 100 / numberOfCharts : 0}%"
		style:opacity={+showLineChartWeapons}
		bind:clientWidth={lineChartWeaponsRealWidth}
	>
		<!-- do not draw the line chart if the width transition is already over i.e. the real width is 0 -->
		{#if lineChartWeaponsRealWidth !== 0}
			<div class="headline" in:fade="{transitionParams}">VERKAUFTE SCHUSSWAFFEN IN DEN USA</div>
			<div class="chart_container" in:fade="{transitionParams}">
				<LineChart
					data={weaponsSold}
					yTicks={weaponsSoldYTicks}
					label={getLastYear}
					formatValueLabel={frmtWeaponsLabel}
					formatTickY={frmtWeapons}
					xTickPosition="top"
					paddingLeft={60}
					seriesColors={[colors.lineWeaponsSold]}
				/>
			</div>
		{/if}
	</div>
</div>

<style lang="scss">
	.shootings {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 50px;
		will-change: width, transform;
		transition: width 0.5s ease, transform 0.5s ease;

		@media (max-width: $breakpoint-mobile) {
			flex-direction: column;
			justify-content: start;
			gap: 30px;
		}

		@media (max-width: 420px) {
			gap: 0;
		}

		&.narrow {
			width: MIN(83%, 1500px);

			@media (max-width: $breakpoint-mobile) {
				width: MIN(75%, 1500px);
			}
		}

		&.lead {
			position: relative;
			transform: scale(0.55) translateX(-44%);

			@media (max-width: $breakpoint-mobile) {
				transform: translateY(50%);
			}

			.headline {
				opacity: 0;
				min-height: 0 !important;
			}
		}
	}

	.headline {
		@include headline;
		min-height: 110px;
		transition: opacity 0.5s ease, padding 0.5s ease;

		@media (max-width: $breakpoint-mobile) {
			.extra-mobile-height & {
				min-height: 70px;
			}
			// min-height: 60px;
			// margin-top: 15px;
		}

		span {
			display: block;
		}
	}

	.container-shootings {
		width: 100%;
		height: 50%;
		max-height: MIN(80vh, 700px);
		will-change: width, height, opacity;
		transition: width 0.5s ease, height 0.5s ease, opacity 0.25s ease-in;

		@media (max-width: 640px) and (min-width: 420px) {
			max-height: MIN(80vh, 300px) !important;
		}

		@media (max-width: $breakpoint-mobile) {
			width: 100% !important;
			max-height: none;
			height: 50%;
			margin-top: 20px;
		}

		.chart_container {
			position: relative;
			height: calc(100% - 100px);

			@media (max-width: $breakpoint-mobile) {
				height: calc(100% - 60px);
			}

			@media (max-width: 640px) and (min-width: 420px) {
				transform: scale(0.9) translateX(-2%);
			}

			@media (max-width: 420px) {
				height: 180px;
				margin-top: 50px;
			}


			&.map {
				min-height: 400px;

				@media (max-width: 640px) {
					min-height: 225px;
					margin-top: 50px;
				}
			}
		}

		&.points {
			height: 50%;

			@media (max-width: $breakpoint-mobile) {
				height: 100%;
			}

			.inner-container {
				width: 100%;
				height: 100%;

				// @media (max-width: $breakpoint-mobile) {
				// 	height: calc(100% - 100px);
				// }


				img {
					max-width: 90%;
					max-height: 80vh;
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);

					@media screen and (min-width: 768px) and (max-width: 1024px) {
						max-width: 80%;
						max-height: 70vh;
					}
				}
			}

			&.map {
				height: 80%;
			}

			&.beeswarm,
			&.histogram {
				width: 70%;
				@media (max-width: $breakpoint-mobile) {
					width: 100%;
				}
			}
		}

		&.linechart-children {
			div {
				// @media (max-width: $breakpoint-mobile) {
				// 	height: calc(100% - 100px);
				// }
			}
		}
	}

	.lead_img {
		mix-blend-mode: screen;
		opacity: 0;
		transition: opacity 1.5s linear;

		&.showImage {
			opacity: 1;
		}
	}

	.pointswrapperwrapperwrapper {
		width: 100%;
		height: 100%;
		opacity: 0;
		filter: brightness(0.8) contrast(1.5);
		transition: opacity 1.7s linear;

		&.showMapMap {
			opacity: 1;
		}

		&.hideFilter {
			filter: none;
			transition: filter 1.7s linear;
		}
	}
</style>
